import { Chip, CircularProgress } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles<any>()({
  chip: {
    borderRadius: '10px',
    background: 'rgba(97, 184, 216, .2)',
    '.MuiChip-label': {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      minWidth: 10,
    },
  },
});

type CounterProps = {
  value: number | null | undefined;
  isLoading?: boolean;
};

export function Counter({ value, isLoading = false }: CounterProps) {
  const { classes } = useStyles(null);

  const getLabel = () => {
    if (isLoading) {
      return (
        <CircularProgress style={{ width: 17, height: 17, color: '#4B4B4B' }} />
      );
    }

    if (value === undefined) {
      return 'N/A';
    }

    return value;
  };

  return (
    <>
      <Chip className={classes.chip} label={getLabel()} />
    </>
  );
}
